import React, { useEffect, useState } from "react";
import { Button, Card, Col, Row, Tooltip, Typography } from "antd";
import { ConnectionCardModal } from "./connection-card-modal";
import { DrawDownFunds } from "./customer-draw-down-funds";
import FFLogo2023_Orange from "../../assets/images/FFLogo2023_Orange2.png";
import { useResponsive } from "../../utils/use-responsive";
import styles from "./black-card.module.scss";

import { QuestionCircleFilled } from "@ant-design/icons";

const { Text, Title } = Typography;

export const BlackCard: React.FC<{
  title?: string;
  subtitle?: string;
  current?: number;
  offer?: string;
  amount?: string;
  tooltip?: string;
}> = ({ title, subtitle, current, offer, amount, tooltip }) => {
  const { isTablet, isMobile, isXs } = useResponsive();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = (status:boolean) => {
    setIsModalOpen(status);
  };

  function getContent() {
    return <DrawDownFunds modalState={showModal}/>;
  }

  return (
    <Card
      bordered={!isMobile}
      className={styles["card"]}
      style={{
        borderRadius: isXs || isMobile || isTablet ? "" : "16px",
        height: isXs || isMobile || isTablet ? "auto" : "170px",
      }}
      cover={
        <Row typeof="flex" justify="space-between">
          <Col style={{ margin: isMobile ? "1.5rem" : "2rem" }}>
            {offer && offer === "drawFunds" && (
              <Text
                type="secondary"
                style={{ color: "white", width: "100%", fontWeight: "lighter" }}
              >
                {title}
              </Text>
            )}

            {!offer ||
              (offer != "drawFunds" && (
                <Title
                  style={{
                    color: "white",
                    width: "100%",
                    fontWeight: "lighter",
                    fontSize: isMobile ? "1.5rem" : "2rem",
                  }}
                >
                  {title}
                </Title>
              ))}

            {offer && offer === "drawFunds" && (
              <Title
                style={{
                  color: "white",
                  width: "100%",
                  fontWeight: "lighter",
                  margin: "0",
                  fontSize: isMobile ? "1.5rem" : "2rem",
                }}
              >
                {amount}{" "}
                <Tooltip
                  placement="top"
                  title={
                    "This is your initial funding amount minus the €3,750.00 (1.5%) facility fee."
                  }
                >
                  <QuestionCircleFilled
                    style={{ fontSize: "18px", color: "#FF930F" }}
                  />
                </Tooltip>
              </Title>
            )}

            <Title
              style={{
                color: "white",
                width: "100%",
                fontWeight: "lighter",
                margin:
                  offer && offer === "drawFunds" ? "0" : "1.2em 0 0.5em 0",
                fontSize: isTablet ? "0.9rem" : "1rem",
              }}
            >
              {subtitle}
            </Title>
          </Col>
          {(!isXs || !isMobile || !isTablet) && (
            <Col
              style={{
                display: "flex",
                justifyContent: "end",
                alignSelf:
                  offer && ["pending", "drawFunds"].includes(offer)
                    ? "center"
                    : "end",
                paddingTop: "20px",
              }}
            >
              {!offer && (
                <img
                  alt="Financefair Logo"
                  src={FFLogo2023_Orange}
                  style={{
                    height: isMobile ? "80px" : isTablet ? "140px" : "150px",
                    width: isMobile ? "130px" : isTablet ? "225px" : "240px",
                  }}
                />
              )}
              {offer && offer === "pending" && (
                <Button
                  type="primary"
                  size="large"
                  className={styles["buttonOffer"]}
                  style={{
                    marginRight: isXs || isMobile || isTablet ? "0px" : "40px",
                  }}
                >
                  Sign Offer
                </Button>
              )}

              {offer && offer === "drawFunds" && (
                <Button
                  type="primary"
                  size="large"
                  className={styles["buttonOffer"]}
                  style={{
                    marginRight: isXs || isMobile || isTablet ? "0px" : "40px",
                  }}
                  onClick={() => showModal(true)}
                >
                  Draw down funds
                </Button>
              )}
            </Col>
          )}
          {(isXs || isMobile || isTablet) && (
            <Col
              style={{
                display: "flex",
                justifyContent: "end",
                alignSelf: "end",
              }}
              className={"full-width"}
            >
              {offer && offer === "pending" && (
                <Button
                  type="primary"
                  size="large"
                  className={styles["buttonOffer"]}
                  style={{
                    margin:
                      isXs || isMobile || isTablet
                        ? "0 40px 20px 40px"
                        : "0 40px 0 0",
                    width: isXs || isMobile || isTablet ? "100%" : "auto",
                  }}
                >
                  Sign Offer
                </Button>
              )}

              {offer && offer === "drawFunds" && (
                <Button
                  type="primary"
                  size="large"
                  className={styles["buttonOffer"]}
                  style={{
                    margin:
                      isXs || isMobile || isTablet
                        ? "0 40px 20px 40px"
                        : "0 40px 0 0",
                    width: isXs || isMobile || isTablet ? "100%" : "auto",
                  }}
                  onClick={() => showModal(true)}
                >
                  Draw down funds
                </Button>
              )}
            </Col>
          )}
        </Row>
      }
    >
      <ConnectionCardModal
        show={isModalOpen}
        title={"Draw down funds"}
        content={getContent()}
        onClose={() => showModal(false)}
      ></ConnectionCardModal>
    </Card>
  );
};
